import DialogContainer, { DialogContainerProps } from './DialogContainer'
import t from '../../../tools/t'
import PrimeIcon from './PrimeIcon'

export default function SupportDialog(props: DialogContainerProps) {
    return (
        <DialogContainer {...props} header={t('support_dialog_title')}>
            <p>{t('support_dialog_message')}</p>
            <br />
            <a href="https://bolt-check.zendesk.com/" target="_blank">
                {t('support_dialog_link_text') + ' '}
                <PrimeIcon size={12} name="arrow-right" />
            </a>
        </DialogContainer>
    )
}
